import React from 'react'
// types
import { FieldType, IField } from 'types/graphql'
// constants
import { SORTABLE_FIELDS } from '../constants'
// components
import SortButton from '../components/SortButton'
import TableHeadLabel from 'components/PageComponents/RiskTemplates/Edit/components/RiskTemplateFields/components/Table/components/TableHead/TableHeadLabel'
// views
import { HeaderItemWrapper } from '../views'
// context
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
// utils
import { orderBy } from 'lodash'

interface Props {
  fields: IField[]
  parentField?: IField
}

const Fields: React.FC<Props> = ({ fields, parentField }) => {
  const { isRisksRegister } = React.useContext(RiskTemplateAPIContext)

  const fieldsToRender = orderBy(
    fields.filter((field) => (parentField ? field.parentFieldId === parentField.id : !field.parentFieldId)),
    'position'
  )

  if (!fieldsToRender.length) {
    return null
  }

  return (
    <>
      {fieldsToRender.map((field) => {
        if (field.fieldType === FieldType.Table || field.fieldType === FieldType.Section) {
          return <Fields key={field.id} parentField={field} fields={fields} />
        }

        // @ts-ignore
        const canSort = !field.fieldLinkId && SORTABLE_FIELDS.includes(field.fieldType)

        return (
          <HeaderItemWrapper key={field.id} data-testid='risk-header-field' data-entity-id={field.id}>
            <TableHeadLabel label={field.label} />
            {isRisksRegister && canSort && <SortButton field={field} />}
          </HeaderItemWrapper>
        )
      })}
    </>
  )
}

export default Fields
